<template>
  <div class="content-container">
    <div class="content">
      <div class="container">
        <div class="row">

          <!-- Title -->
          <div class="col-12">
            <div class="title">
              <h1>Choose your repair solution</h1>
              <h4>We are unable to provide a Doorstep Repair in your chosen location</h4>
            </div>
          </div>

          <!-- Options -->
          <div class="col-12">
            <div class="card-grid grid-col-2 row">


<!--              &lt;!&ndash; Doorstep service &ndash;&gt;-->
<!--              <div class="card" @click="nextStep()" style="cursor: pointer;">-->
<!--                <div class="card-body">-->
<!--                  <div class="card-img repair-type">-->
<!--                    <img -->
<!--                         src="/img/icons/doorstep-repair.webp">-->
<!--                  </div>-->
<!--                  <h5>-->
<!--                    Doorstep Repair-->
<!--                  </h5>-->
<!--                  <p class="text-sm">-->
<!--                    A mobile repair van comes to you on the day and repairs your product on-site.-->
<!--                  </p>-->
<!--                  <br/>-->
<!--                  <p class="text-sm">-->
<!--                    Appointments for Doorstep Repair service can be up to 12 days from time of booking.-->
<!--                    Repairs can be completed on the day of the appointment.-->
<!--                  </p>-->
<!--                </div>-->
<!--              </div>-->
              <!-- Pickup repair -->
              <div class="card" @click="goToSamsung()" style="cursor: pointer;">
                <div class="card-body">
                  <div class="card-img repair-type">
                    <img
                         src="/img/icons/pickup-repair.webp" />
                  </div>
                  <h5>
                    Pickup Repair
                  </h5>
                  <p class="text-sm">
                    A courier comes to you, takes away your device for repair and returns it once complete.
                  </p>
                  <br/>
                  <p class="text-sm">
                    Pick up service repair times can take up to 10 days from date of collection.
                  </p>
                </div>
              </div>
              <!-- In-store -->
              <div class="card" @click="goToSamsung()" style="cursor: pointer;">
                <div class="card-body">
                  <div class="card-img repair-type">
                    <img
                          src="/img/icons/instore-repair.webp" />
                  </div>
                  <h5>
                    In-store repair
                  </h5>
                  <p class="text-sm">
                    Book a slot to drop off your product in store with a Samsung Expert.
                  </p>
                  <br/>
                  <p class="text-sm">
                    In-store repair times can take up to 2 days from date of drop off.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
        <!-- Footer -->
        <footer class="footer" :class="footerClass">
          <div class="container">
            <router-link :to="{ name: 'postcodeSearch' }" style="margin: 0 auto;"
                         class="btn btn-primary btn-lg back-btn"><i
                class="fa fa-chevron-left ml-1 text-sm"></i> Try a different postcode</router-link>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'RepairOptions',

  data() {
    return {
    }
  },

  computed: {
    ...mapGetters([
      'carrier',
    ]),

    pageTitle() {
      return "Choose your repair solution";
    },

    footerClass() {
      return (window.innerHeight < 768) ? "fixed-footer" : "";
    }
  },

  methods: {

    goToSamsung() {
      window.location.href = "https://www.samsung.com/uk/support/repair";
    },
  }
}
</script>

<style scoped>

</style>